module.exports = __webpack_public_path__ + "img/rueckgabe-icon-data.cb73e677.svg";